module.exports = __webpack_public_path__ + "img/verve.ba57d33e.svg";